import React from "react";
import Chart from "react-apexcharts";
const Report = ({ countValue }) => {
  const [state, setState] = React.useState({
    options: {
      chart: {
        id: "basic-bar",
      },
      xaxis: {
        categories: countValue?.map((item) => item.name),
      },
      colors: ["#E4780E", "#E91E63", "#9C27B0"],
      dataLabels: {
        style: {
          colors: ["#fff", "#fff", "#fff"],
        },
      },
      fill: {
        colors: ["#E4780E", "#E91E63", "#9C27B0"],
      },
      markers: {
        colors: ["#E4780E", "#E91E63", "#9C27B0"],
      },
    },
    series: [
      {
        name: "Pickup Product",
        data: countValue?.map((item) => item.value),
      },
    ],
  });
  return (
    <div className="app">
      <div className="row">
        <div className="mixed-chart">
          <Chart
            options={state.options}
            series={state.series}
            type="bar"
            width="1000"
          />
        </div>
      </div>
    </div>
  );
};
export default Report;
